import { render } from "./NavigationList.vue?vue&type=template&id=0b88c988&scoped=true"
import script from "./NavigationList.vue?vue&type=script&lang=js"
export * from "./NavigationList.vue?vue&type=script&lang=js"

import "./NavigationList.vue?vue&type=style&index=0&id=0b88c988&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b88c988"]])

export default __exports__